import commonservice from "@apis/commonservice";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { IconSelect } from "@icons/index";
import report from "@report";
import { updateLanguage } from "@store/globalSlice";
import DropdownItem from "@components/DropdownItem";
import { Dropdown } from "antd";
import { Trans } from "react-i18next";

export default function LanguageSelector() {
  const { language } = useAppSelector((state) => state.globalReducer);
  const { languageOptions } = useAppSelector((state) => state.configReducer);
  const languageLabel = languageOptions.find((option) => option.value === language)?.label;

  const dispatch = useAppDispatch();

  const languageItems = languageOptions.map((option) => {
    return {
      key: option.value,
      label: (
        <DropdownItem selected={language === option.value} className="h-[38px] leading-[38px]">
          <div>{option.label}</div>
        </DropdownItem>
      ),
    };
  });

  return (
    <div className="flex flex-col gap-[16px] py-[32px] border-b border-kds-border">
      <div className="text-[16px] font-medium">
        <Trans i18nKey="user_language">Language</Trans>
      </div>
      <Dropdown
        menu={{
          items: languageItems,
          onClick: async ({ key: value }) => {
            report.click({ kalo_pos: "modifyProfile", kalo_value: value, kalo_type: "language" });
            dispatch(updateLanguage(value));
            await commonservice.modifyProfile({ language: value });
          },
        }}
      >
        <div className="w-[238px] h-[40px] border border-kds-border rounded cursor-pointer px-[12px] flex flex-row items-center justify-between">
          {languageLabel}
          <IconSelect></IconSelect>
        </div>
      </Dropdown>
    </div>
  );
}
